export default {
  info: '#6FCFEB',
  primary: '#00adee',
  success: '#00adee',
  warning: '#f68e56',
  danger: '#EB0045',
}
